const API = process.env.REACT_APP_BACKEND_URL;

const req = async (path, opts = {}) => {
  const r = await fetch(`${API}/api${path}`, { credentials: "include", ...opts });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) {
    const det = d.detail;
    const err = new Error(typeof det === "string" ? det : det?.message || `Request failed (${r.status})`);
    err.detail = det;
    throw err;
  }
  return d;
};

const json = (body) => ({ method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });

export const inspectionApi = {
  list: () => req("/inspection/list"),
  projects: () => req("/admin/projects"),
  get: (id) => req(`/inspection/${id}`),
  start: (body) => req("/inspection/start", json(body)),
  finding: (id, body) => req(`/inspection/${id}/finding`, json(body)),
  complete: (id, body) => req(`/inspection/${id}/complete`, json(body)),
  dims: (id, body) => req(`/inspection/${id}/dimensions`, json(body)),
  hub: (id) => req(`/render-hub/${id}`),
  hubRecent: () => req("/render-hub/recent"),
  hubPublic: (tok) => req(`/public/render-hub/${tok}`),
  hubPalette: (id, palette_id) => req(`/render-hub/${id}/palette`, json({ palette_id })),
  hubRender: (id, room_key, palette_id) => req(`/render-hub/${id}/render`, json({ room_key, palette_id })),
  hubApprove: (id) => req(`/render-hub/${id}/approve-procurement`, { method: "POST" }),
  hubShare: (id) => req(`/render-hub/${id}/share`, { method: "POST" }),
  apiBase: API,
  hunterScan: (id) => req(`/inspection/${id}/hunter-scan`, { method: "POST" }),
  upload: (id, form) => req(`/inspection/${id}/photo`, { method: "POST", body: form }),
  photoUrl: (photoId) => `${API}/api/inspection/photo/${photoId}`,
};
